import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ICDDiagnose } from 'app/_models/icd-diagnose.model';
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CedNotificationService } from "ced-ng-library";
import { environment } from "environments/environment";

@Component({
  selector: 'app-edit-icd-diagnose',
  templateUrl: './edit-icd-diagnose.component.html',
  styleUrls: ['./edit-icd-diagnose.component.scss']
})
export class EditIcdDiagnoseComponent implements OnInit, OnDestroy {

  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  @Input() modId;
  @Input() icdDiagnose;
  @Output() Change: EventEmitter<{
    dialogstatus;
    icdDiagnose;
  }> = new EventEmitter();
  UpdateDialogOpened = false;
  public ICDDiagnoseForm: FormGroup;
  public ICDDiagnose = new ICDDiagnose();
  @Input() gridData = [];
  existingCode: boolean = false;
  private subject$ = new Subject();

  constructor(
    private commonService: CommonService, 
    private cedNotificationService: CedNotificationService
    )
     { }
 
  ngOnInit() {
    this.ICDDiagnoseForm = new FormGroup({
      icdCode: new FormControl("", Validators.required),
      icdName: new FormControl("", Validators.required),
      icdIsActive: new FormControl(false),
      icdComment: new FormControl("")
    });
    this.ICDDiagnoseForm.patchValue(this.icdDiagnose);
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.ICDDiagnoseForm.controls[controlName].hasError(errorName);
  };

  public CreateicdDiagnose = (ICDDiagnoseFormValue) => {
      this.checkCode(this.ICDDiagnoseForm.controls['icdCode'].value,this.icdDiagnose.icdId, ICDDiagnoseFormValue); 
  };
  
   checkCode(code:string, icdId: string  , ICDDiagnoseFormValue ){
     if(JSON.stringify(this.ICDDiagnoseForm.controls['icdCode'].value) == JSON.stringify(this.icdDiagnose.icdCode) ){
      this.ExecuteicdDiagnoseCreation(ICDDiagnoseFormValue);
     }
     else if(this.icdDiagnose.icdId == undefined){  
      let getByCodeUrl: string = `IcdDiagnose/GetByCode/`+code;
      this.commonService.getData(getByCodeUrl, this.serverUrlSlot3).pipe(takeUntil(this.subject$))
        .subscribe((data: any) => {
          this.existingCode = (data != null || this.gridData.some(e=>e.icdCode == code));
          if(this.existingCode){
            this.cedNotificationService.error("NOTIFICATIONS.ICD_CODE_SHOULD_BE_UNIQUE")      
          }
          else if (this.ICDDiagnoseForm.valid) {
            this.ExecuteicdDiagnoseCreation(ICDDiagnoseFormValue);
          }
        });
     }
     else{
      let getByCodeUrl: string = `IcdDiagnose/GetByCodeAndId/`+code + '/'+icdId ;
      this.commonService.getData(getByCodeUrl, this.serverUrlSlot3).pipe(takeUntil(this.subject$))
        .subscribe((data: any) => {
          this.existingCode = (data != null || this.gridData.some(e=>e.icdCode == code && e.icdId != icdId));
          if(this.existingCode){
            this.cedNotificationService.error("NOTIFICATIONS.ICD_CODE_SHOULD_BE_UNIQUE")      
          }
          else if (this.ICDDiagnoseForm.valid) {
            this.ExecuteicdDiagnoseCreation(ICDDiagnoseFormValue);
          }
        });
     }
  }

  private ExecuteicdDiagnoseCreation = (ICDDiagnoseFormValue) => {
    this.icdDiagnose.icdCode = ICDDiagnoseFormValue.icdCode;
    this.icdDiagnose.icdName = ICDDiagnoseFormValue.icdName;
    this.icdDiagnose.icdIsActive = ICDDiagnoseFormValue.icdIsActive;
    this.icdDiagnose.icdComment = ICDDiagnoseFormValue.icdComment;
    this.icdDiagnose.icdMidOfficeDiagnoseId = this.modId;
    if (this.icdDiagnose.icdId != undefined) {
      this.icdDiagnose.icdId = this.icdDiagnose.icdId;
      let UpdateICDDiagnoseUrl = `IcdDiagnose/Update`;
      this.commonService.update(UpdateICDDiagnoseUrl, this.icdDiagnose).pipe(takeUntil(this.subject$)).subscribe((data) => {
      })
      this.Change.emit({
        icdDiagnose: this.icdDiagnose,
        dialogstatus: this.UpdateDialogOpened,
      });
    }
    else{
      this.Change.emit({
        icdDiagnose: this.icdDiagnose,
        dialogstatus: this.UpdateDialogOpened,
      });    
    }
  };

  public Cancel() {
    this.Change.emit({ dialogstatus: this.UpdateDialogOpened, icdDiagnose: "" });
  }
  ngOnDestroy(): void {
    this.subject$.unsubscribe();
  }
}